import { htmlEscape } from "../../../../utils/vanilla";

const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export const createMonthDaysNames = (t: (s: string) => string) => {
    const translate = (arr: string[], pos = 0, postfix = "") => arr.map(a => {
        let part = pos ? a.substring(0, pos) : a;
        return t(part + postfix) || part;
    });

    return {
        monthNames: translate(monthNames),
        dayNames: translate(dayNames),
        shortMonthNames: translate(monthNames, 3, "_short"),
        shortDayNames: translate(dayNames, 3)
    };
};

export function splitDateAndTime (pattern?: string) {
    const defaultTimeFormat = "HH:mm:ss";
    const defaultDateFormat = "MM/dd/yy";
    if (!pattern) {
        return {
            date: defaultDateFormat,
            time: defaultTimeFormat
        };
    }

    const pos = pattern.search(/h/i);

    let date = pattern;
    let time = defaultTimeFormat;

    if (pos !== -1) {
        date = pos === 0 ? defaultDateFormat : pattern.slice(0, pos - 1) || defaultDateFormat;
        time = pattern.slice(pos) || defaultTimeFormat;
    }

    return {
        date: date.trim(),
        time: time.trim()
    };
}

const monthsDaysNames = createMonthDaysNames(s => s);

export function toStringFormat (dateSource, format: string, useUtc?: boolean, roundToNearestSecond = true) {
    let date = new Date(dateSource);
    if (roundToNearestSecond) {
        // Excel rounds up to the nearest second, do the same thing to keep consistency
        date.setTime(Math.round(date.getTime() / 1000) * 1000);
    }

    let token = /d{1,4}|M{1,4}|yy(?:yy)?|y|([HhmsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
        padString = function (valStr, len = 2) {
            let val = valStr.toString();
            while (val.length < len) {
                val = "0" + val;
            }
            return val;
        },
        _ = "get",
        utc = useUtc ? "UTC" : "",
        d = date[_ + utc + "Date"](),
        day = date[_ + utc + "Day"](),
        m = date[_ + utc + "Month"](),
        y = date[_ + utc + "FullYear"](),
        hours = date[_ + utc + "Hours"](),
        minutes = date[_ + utc + "Minutes"](),
        s = date[_ + utc + "Seconds"](),
        mills = date[_ + utc + "Milliseconds"](),
        flags = {
            d: d,
            dd: padString(d),
            ddd: monthsDaysNames.shortDayNames[day],
            dddd: monthsDaysNames.dayNames[day],
            M: m + 1,
            MM: padString(m + 1),
            MMM: monthsDaysNames.shortMonthNames[m],
            MMMM: monthsDaysNames.monthNames[m],
            y: parseInt(y.toString().slice(2)),
            yy: y.toString().slice(2),
            yyyy: y,
            h: hours % 12 || 12,
            hh: padString(hours % 12 || 12),
            H: hours,
            HH: padString(hours),
            m: minutes,
            mm: padString(minutes),
            s: s,
            ss: padString(s),
            l: padString(mills, 3),
            L: padString(mills > 99 ? Math.round(mills / 10) : mills),
            t: hours < 12 ? "a" : "p",
            tt: hours < 12 ? "am" : "pm",
            T: hours < 12 ? "A" : "P",
            TT: hours < 12 ? "AM" : "PM"
        };

    return htmlEscape(format).replace(token, function (character) {
        return character in flags ? flags[character] : character.slice(1, character.length - 1);
    });
}